// export const BASE_URL = "https://kitchenhamara.com/api";
//export const BASE_URL = "https://kitchenhereapp.herokuapp.com";
// export const BASE_URL = "https://206.189.129.95/api"
// export const BASE_URL = 'http://localhost:8080/api'
export const BASE_URL='/api'
// export const BASE_URL = "http://backend:8080/api"